/**
 * @generated SignedSource<<68bbefcd8c80968d3a5f5390fea86d25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orderId",
        "variableName": "orderId"
      }
    ],
    "concreteType": "Order",
    "kind": "LinkedField",
    "name": "UserSubmittedOrder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowedCustomerActions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primeCustomerAction",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CoverCollectModalSubmitMutation",
    "selections": (v1/*: any*/),
    "type": "ClientAppMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CoverCollectModalSubmitMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c187e084b822d2753d36d61e199cee68",
    "id": null,
    "metadata": {},
    "name": "CoverCollectModalSubmitMutation",
    "operationKind": "mutation",
    "text": "mutation CoverCollectModalSubmitMutation(\n  $orderId: Int!\n) {\n  UserSubmittedOrder(orderId: $orderId) {\n    id\n    status\n    statusName\n    allowedCustomerActions\n    primeCustomerAction\n  }\n}\n"
  }
};
})();

node.hash = "a1f5b0678ca1a1e471d4c09dea72705b";

module.exports = node;
